<flexyoo-generic-page-with-logo
  [isLoading]="(isLoading$ | async) || (isNavigating$ | async)"
  [width]="loginFlow.kind === 'choose-role' ? 'auto' : '400px'"
>
  <ng-container content>
    @switch (loginFlow.kind) {
      @case ('before-start') {
        <div class="flexyoo-login-form">
          <form autocomplete="on" id="EmailForm" [formGroup]="form" (ngSubmit)="chooseAuthSchema()">
            <mat-form-field>
              <mat-label class="placeholder">Email</mat-label>
              <input formControlName="email" matInput name="username" type="username" />
              <input hidden name="password" type="password" value="" />
            </mat-form-field>
            @if (userNotFoundError$ | async) {
              <mat-error>{{ 'error_codes.USER_NOT_FOUND' | translate }}</mat-error>
            }
            @if (ssoNotAuthorised$ | async) {
              <mat-error>{{ 'error_codes.SSO_UNAUTHORIZED' | translate }}</mat-error>
            }
            @if (userAgreementApprovedError$ | async) {
              <mat-error>{{
                'both-languages.user-agreement-approve-waiting' | translate
              }}</mat-error>
            }
            <button
              matButton="filled"
              style="display: block; font-size: 20px; margin: 10px auto 0"
              type="submit"
              [disabled]="!form.enabled" class="fo-color-secondary"
            >
              {{ 'both-languages.next' | translate }}
            </button>
          </form>
        </div>
      }
      @case ('user-sign-agreement-expired') {
        <div class="flexyoo-login-form">
          <div style="color: #400230; font-weight: bold">
            {{ 'auth.user-agreement-date-expired' | translate }}
          </div>
          <br />
          <a class="login-form-link" (click)="returnToEmail()">
            {{ 'base-layout.back' | translate }}</a
          >
        </div>
      }
      @case ('start') {
        <div class="flexyoo-login-form">
          @if (passwordNotSetError$ | async) {
            <div class="password-not-set-error">
              <span class="password-not-set-error-title"> {{ 'general.welcome' | translate }}</span>
              {{ 'account.password-not-set-info' | translate }}
            </div>
          }
          <form id="LoginForm" [formGroup]="form" (ngSubmit)="submit()">
            @if (tenantIsNotActiveError) {
              <mat-error>{{ 'both-languages.tenant-is-not-active' | translate }}</mat-error>
            }
            @if (employeeIsNotActiveError) {
              <mat-error>{{ 'both-languages.employee-is-not-active' | translate }}</mat-error>
            }
            <mat-form-field style="background-color: rgb(200, 221, 218)">
              <mat-label class="placeholder">Email</mat-label>
              <input formControlName="email" matInput readonly type="username" />
            </mat-form-field>
            <mat-form-field>
              <mat-label class="placeholder">{{ 'both-languages.password' | translate }}</mat-label>
              <input formControlName="password" matInput type="password" />
            </mat-form-field>
            @if (basicAuthFailed$ | async) {
              <mat-error>{{ 'both-languages.authentication-failed' | translate }}</mat-error>
            }
            <div style="display: flex; justify-content: space-between; margin-top: 20px">
              <a class="login-form-link" (click)="returnToEmail()">
                {{ 'base-layout.back' | translate }}</a
              >
              <a class="login-form-link" routerLink="../reset-password">{{
                'both-languages.forgot-password' | translate
              }}</a>
            </div>
            <br />
            @if (userAgreementApprovedError$ | async) {
              <div
                style="color: #400230; font-weight: bold"
                [innerHtml]="'both-languages.user-agreement-approve-waiting' | translate"
              ></div>
            }
            <br />
            <button
              matButton="filled"
              style="display: block; font-size: 20px; margin: 0 auto"
              type="submit"
              [disabled]="!form.enabled" class="fo-color-secondary"
            >
              {{ 'both-languages.confirm' | translate }}
            </button>
          </form>
        </div>
      }
      @case ('choose-role') {
        <app-login-multirole
          [roles]="loginFlow.roles"
          [userName]="loginFlow.result.userName"
          (roleSelected)="onRoleSelected($event)"
        ></app-login-multirole>
      }
      @case ('choose-user') {
        <div class="flexyoo-login-as-form">
          <div class="flexyoo-login-as-form__title">
            {{ 'auth.hello' | translate }} {{ loginFlow?.result?.userName }}
          </div>
          <div class="flexyoo-login-as-form__description">{{ 'auth.choose-role' | translate }}</div>
          @for (user of loginFlow.result.users; track user.user.Id) {
            <button class="login-as fo-color-secondary" matButton="filled" (click)="loginAsUser(user)">
              {{ formatTenantName(user.user) }}
            </button>
          }
        </div>
      }
    }
    @if (
      (loginFlow.kind === 'choose-role' || loginFlow.kind === 'choose-user') &&
      (authScheme$ | async) === 'Basic'
    ) {
      <br />
      <a class="login-form-link" (click)="back()"><< {{ 'auth.back-to-chose-role' | translate }}</a>
    }
  </ng-container>
  <div class="copyright" footer>{{ currentYearLong() }} {{ 'general.copyright' | translate }}</div>
</flexyoo-generic-page-with-logo>
